import {
  Component,
  Input,
  OnInit,
  ViewChild,
  ChangeDetectorRef
} from "@angular/core";
import {
  MdbTablePaginationComponent,
  MdbTableDirective
} from "ng-uikit-pro-standard";
import { ByActiveDays, FirebaseService } from "src/app/core";

@Component({
  selector: "ll-summary-by-active-days",
  templateUrl: "./summary-by-active-days.component.html",
  styleUrls: ["./summary-by-active-days.component.scss"]
})
export class SummaryByActiveDaysComponent implements OnInit {
  // @ViewChild(MdbTablePaginationComponent, { static: true })
  // mdbTablePagination: MdbTablePaginationComponent;
  @ViewChild(MdbTableDirective, { static: true }) mdbTable: MdbTableDirective;
  previous: ByActiveDays[] = [];
  @Input() venue: boolean;

  public isLoading: boolean = true;
  constructor(private cdRef: ChangeDetectorRef, public fb: FirebaseService) {}
  get data() {
    return this.fb.analytics.byActiveDays != null
      ? this.fb.analytics.byActiveDays
      : [];
  }
  ngOnInit() {
    this.mdbTable.setDataSource(this.data);
    this.data.sort((a, b) => b.total - a.total);
  }

  ngAfterViewInit(): void {
    this.done();
  }

  done() {
    setTimeout(() => (this.isLoading = false), 1500);
  }

  get tUnits(): number {
    return this.data.reduce((acc, next) => acc + next.units, 0);
  }
  get tAvgPrice(): number {
    return (
      this.data.reduce((acc, next) => acc + next.avg_price * next.units, 0) /
      this.tUnits
    );
  }

  get tSubtotal() {
    return this.data.reduce((acc, next) => acc + next.subtotal, 0);
  }

  get tServiceFees() {
    return this.data.reduce((acc, next) => acc + next.service_fees, 0);
  }
  get tTips() {
    return this.data.reduce((acc, next) => acc + next.tips, 0);
  }
  get tTipPercentage() {
    return (
      this.data.reduce((acc, next) => acc + next.tip_percentage, 0) /
      this.data.length
    );
  }
  get tTotal() {
    return this.data.reduce((acc, next) => acc + next.total, 0);
  }
  get tRedeemed() {
    return this.data.reduce((acc, next) => acc + next.redeemed, 0);
  }
  get tRedeemedPercentage() {
    // if (this.venue) return this.tRedeemed / this.fb.venue.orders.orders.length;
    return this.tRedeemed / this.fb.orders.orders.length;
  }
  get tRevenue() {
    return (
      this.data.reduce((acc, next) => acc + next.revenue_percentage, 0) /
      this.data.length
    );
  }

  setItemsPerPage(item: number) {
    this.filter.showing = item;
    this.filter.firstIndex = 0;
    this.filter.lastIndex = item;
    this.mdbTable.setDataSource(this.data);
  }

  show(i: number) {
    return this.filter.show(i);
  }
  increment() {
    this.filter.increment();
  }
  decrement() {
    this.filter.decrement();
  }

  get filter() {
    return this.fb.analytics.filter;
  }
}
